var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import NbnCard from './nbn-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment NbnCard on Property {\n    address {\n      nbnDetails {\n        technology {\n          abbreviation\n          description\n          brandName\n          brand\n        }\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _address$nbnDetails;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$address = _ref.address,
    address = _ref$address === void 0 ? {} : _ref$address;
  return _objectSpread({}, (_address$nbnDetails = address.nbnDetails) === null || _address$nbnDetails === void 0 ? void 0 : _address$nbnDetails.technology);
};
export var NbnCardGraphQL = _ref2 => {
  var _property$address, _property$address$nbn;
  var property = _ref2.property;
  return (_property$address = property.address) !== null && _property$address !== void 0 && (_property$address$nbn = _property$address.nbnDetails) !== null && _property$address$nbn !== void 0 && _property$address$nbn.technology ? ___EmotionJSX(NbnCard, graphQLToProps(property)) : null;
};
NbnCardGraphQL.fragment = fragment;
NbnCardGraphQL.propTypes = {
  property: PropTypes.shape({
    address: PropTypes.shape({
      nbnDetails: PropTypes.shape({
        technology: PropTypes.shape({})
      })
    })
  })
};
NbnCardGraphQL.defaultProps = {
  property: {}
};